import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { getErrorLevelSelect, getErrorLevelString } from 'src/app/error-engine/shared/enums/error-level.enum';
import { getErrorTypeSelect, getErrorTypeString } from 'src/app/error-engine/shared/enums/error-type.enum';
import { ErrorThreshold } from 'src/app/error-engine/shared/interfaces/error-threshold.interface';
import { ErrorThresholdParameters } from 'src/app/error-engine/shared/interfaces/error-threshold-parameters.interface';
import { ErrorThresholdService } from 'src/app/error-engine/shared/service/error-threshold.service';
import { BrennstoffzellenHistoryComponent } from 'src/app/project/project-schema/shared/components/brennstoffzellen-history/brennstoffzellen-history.component';
import { DataEndChannel } from 'src/app/project/shared/interfaces/data-end-channel.interface';
import { AlertTypes } from 'src/app/shared/alert/shared/alert-types';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';
import { SelectInput } from 'src/app/shared/dropdown/shared/select-input.class';

@Component({
  selector: 'avs-create-edit-error-treshold',
  standalone: false,
  templateUrl: './create-edit-error-treshold.component.html',
  styleUrl: './create-edit-error-treshold.component.css'
})
export class CreateEditErrorTresholdComponent {

  public errorThreshold: ErrorThreshold = { dataEndChannelId: 0, errorThresholdParameters: [] };
  public errorThresholdParameters: ErrorThresholdParameters[] = [];
  public existingErrorThresholdParameters: ErrorThresholdParameters[] = [];
  public isErrorLevelDropdownOpen = false;
  public isErrorTypeDropdownOpen = false;

  public errorLevelSelect: SelectInput[] = getErrorLevelSelect();
  public errorTypeSelect: SelectInput[] = getErrorTypeSelect();

  public kanal?: DataEndChannel;
  public isEditActive = false;
  public tresholdValueToggle: boolean = false;
  private _tresholdValue: number = 0;

  get tresholdValue(): boolean {
    return this._tresholdValue === 1;
  }

  set tresholdValue(value: boolean) {
    this._tresholdValue = value ? 1 : 0;
  }
  protected readonly getErrorLevelString = getErrorLevelString;
  protected readonly getErrorTypeString = getErrorTypeString;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<BrennstoffzellenHistoryComponent>,
    private errorTresholdService: ErrorThresholdService,
    public alertService: AlertService) { }

  public ngOnInit(): void {

    this.errorTresholdService.getErrorThreshold(this.data.dataEndChannel.id).subscribe((x: ErrorThresholdParameters[]) => {
      if (x) {
        this.existingErrorThresholdParameters = x;
      } else {
        this.errorThreshold = { dataEndChannelId: 0, errorThresholdParameters: [] };
      }
    });

    this.errorThreshold!.dataEndChannelId = this.data.dataEndChannel.id;
    this.kanal = this.data.dataEndChannel;

    this.existingErrorThresholdParameters.forEach((treshold) => {
      treshold.changed = false;
    });
    this.tresholdValueToggle = this.existingErrorThresholdParameters.length > 0 ? this.existingErrorThresholdParameters[0].tresholdValue === 1 : false;
    this.addErrorTresholdparameters();
  }

  public addErrorTresholdparameters(): void {
    this.errorThresholdParameters.push({});
    this.errorThreshold!.errorThresholdParameters = this.errorThresholdParameters;
  }

  public onErrorLevelDropdownClicked(): void {
    this.isErrorLevelDropdownOpen = !this.isErrorLevelDropdownOpen;
  }

  public onErrorLevelSelectClicked(item: SelectInput, treshold: ErrorThresholdParameters): void {
    treshold.errorLevel = Number(item.id);
    this.isErrorLevelDropdownOpen = false;
  }

  public onErrorTypeDropdownClicked(): void {
    this.isErrorTypeDropdownOpen = !this.isErrorTypeDropdownOpen;
  }

  public onErrorTypeSelectClicked(item: SelectInput, treshold: ErrorThresholdParameters): void {
    treshold.errorType = Number(item.id);
    this.isErrorTypeDropdownOpen = false;
  }

  onTresholdValueToggleChanged(event: any, param: ErrorThresholdParameters): void {
    param.tresholdValue = event ? 1 : 0;
    param.changed = true;
    this.tresholdValueToggle = event.checked;
  }

  public createErrorTreshold(): void {
    this.errorTresholdService.createErrorThreshold(this.errorThreshold!).subscribe((x: ErrorThresholdParameters[]) => {
      this.existingErrorThresholdParameters = x;
      this.errorThresholdParameters = [];
      this.alertService.alert('Schwellenwert erstellt', AlertTypes.info);
    });
  }

  isDuplicateErrorLevelAndTypeOfNewParams(errorThresholdParameter: ErrorThresholdParameters): boolean {
    let errorThresholdParameterDuplicated = this.errorThresholdParameters.filter((treshold) =>
      treshold.errorLevel === errorThresholdParameter.errorLevel && treshold.errorType === errorThresholdParameter.errorType);
    return errorThresholdParameterDuplicated.length > 1;
  }

  isDuplicateErrorLevelAndTypeOfExisting(errorThresholdParameter: ErrorThresholdParameters): boolean {
    let errorThresholdParameterDuplicated = this.existingErrorThresholdParameters.filter((treshold) =>
      treshold.errorLevel === errorThresholdParameter.errorLevel && treshold.errorType === errorThresholdParameter.errorType);
    return errorThresholdParameterDuplicated.length > 1;
  }

  public onCloseDialogClicked(): void {
    this.dialogRef.close(this.existingErrorThresholdParameters);
  }

  public editTresholdParameter(param: ErrorThresholdParameters): void {
    this.errorTresholdService.updateErrorThresholdParameter(param).subscribe(
      () => {
        this.alertService.alert('Schwellenwert überarbeitet', AlertTypes.info);
      },
      () => {
        this.alertService.alert('Fehler beim bearbeiten', AlertTypes.error);
      }
    );
    param.changed = false;
  }

  public deleteTresholdParameter(param: ErrorThresholdParameters): void {
    this.errorTresholdService.deleteErrorThresholdParameter(param.id!).subscribe(
      () => {
        this.alertService.alert('Schwellenwert gelöscht', AlertTypes.info);
        this.existingErrorThresholdParameters = this.existingErrorThresholdParameters.filter((treshold) => treshold.id !== param.id);
      },
      () => {
        this.alertService.alert('Fehler beim löschen', AlertTypes.error);
      }
    )
  }
}
